import type { Option } from "@/ui/components/Dropdown"

export const bankTypeOptions: Option[] = [
  {
    value: "BRI",
    label: "BRI"
  },
  {
    value: "BCA",
    label: "BCA"
  },
  {
    value: "MANDIRI",
    label: "MANDIRI"
  }
]
